"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectiveClaimsView = EffectiveClaimsView;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const oidc_client_ts_1 = require("oidc-client-ts");
const client_config_1 = require("../../../../../client-config");
const Actions = __importStar(require("../actions"));
const elements_1 = require("../elements");
function EffectiveClaimsView({ input, showError, userSearchedClaims, claims, dispatch }) {
    const setInput = (input) => dispatch(Actions.setInput(input));
    const setShowError = (showError) => dispatch(Actions.setShowError(showError));
    const setUserSearchedClaims = (claims) => dispatch(Actions.setUserSearchedClaims(claims));
    const effectiveClaims = userSearchedClaims !== undefined ? userSearchedClaims : claims;
    return (React.createElement(Elements.StandardContainer, null,
        React.createElement(SearchClaimsComponent, { input: input, showError: showError, setInput: setInput, setShowError: setShowError, setUserSearchedClaims: setUserSearchedClaims }),
        React.createElement("br", null),
        userSearchedClaims === undefined
            ? "Showing your claims"
            : "Showing claims for: " + input,
        React.createElement("br", null),
        Object.keys(effectiveClaims).map(context => claimContextGroup(context, effectiveClaims[context]))));
}
function claimContextGroup(context, 
// biome-ignore lint: -
claims) {
    return (React.createElement(Elements.StandardContainer, { key: context },
        React.createElement(Elements.ListHeader, null, context),
        Object.keys(claims).map(claimKey => (React.createElement(Elements.StandardContainer, { key: `${context};${claimKey}` },
            React.createElement("span", null,
                claimKey,
                " = ",
                claims[claimKey].reduce((a, b) => a + ";" + b)))))));
}
function SearchClaimsComponent({ input, setInput, setShowError, setUserSearchedClaims, showError }) {
    return (React.createElement(elements_1.StyledFieldset, null,
        React.createElement("legend", null, "User"),
        React.createElement("div", null,
            React.createElement(Elements.InputText, { value: input, onChange: e => {
                    setInput(e.target.value);
                }, onKeyDown: e => e.keyCode === 13 &&
                    onClick(input, setShowError, setUserSearchedClaims) }),
            React.createElement(Elements.StandardButton, { onClick: () => onClick(input, setShowError, setUserSearchedClaims) }, "Get claims")),
        showError && React.createElement("p", null, "There was an error trying to impersonate")));
}
async function onClick(userName, setShowError, setUserSearchedClaims) {
    const manager = new oidc_client_ts_1.UserManager({
        authority: client_config_1.config.oidcAuthority,
        client_id: client_config_1.config.oidcClientId,
        redirect_uri: client_config_1.config.oidcRedirectUri,
        response_type: client_config_1.config.oidcResponseType,
        scope: client_config_1.config.oidcScope,
        monitorSession: false,
        loadUserInfo: false,
        automaticSilentRenew: client_config_1.config.oidcResponseType === "code"
    });
    const user = await manager.getUser();
    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + (user === null || user === void 0 ? void 0 : user.access_token)
        }
    };
    const response = await fetch(`/effectiveclaims?username=${userName}`, options);
    if (response.ok) {
        const responseJson = await response.json();
        setUserSearchedClaims(responseJson.claims);
    }
    else {
        setShowError(true);
    }
}
//# sourceMappingURL=effective-claims-component.js.map